import React from "react";

const ViewAutoHistory = () => {
  return <div>ViewAutoHistory</div>;
};
export default ViewAutoHistory;
